import React from 'react'
import { OfferItem } from './OfferItem'
import { ErrorState } from '../../Components/ErrorState'
import { isDebtCalcError } from '../utils'
import { InputState } from '../config'
import { truncArray } from 'lib'
import { DebtConsolidationCalcResult } from 'generated/api'
import { ListWrapper } from './ListWrapper'
import { DataWrapper } from 'components/patterns/suspense/internals/types'

interface Props {
	inputState: InputState
	data: DataWrapper<DebtConsolidationCalcResult>
}

export const ResultList: React.FC<React.PropsWithChildren<Props>> = ({ inputState, data }) => {
	const result = data.read()

	if (isDebtCalcError(result.monthlyPaymentSummary?.savings)) {
		return <ErrorState />
	}

	const threeOffers = truncArray(result.exampleOffers, 3)

	return (
		<ListWrapper>
			<>
				{threeOffers?.map((item, index) => {
					return <OfferItem key={index} offer={item} inputState={inputState} />
				})}
			</>
		</ListWrapper>
	)
}
